import { Link } from "react-router-dom";

export default function OrderCancel() {
  return (
    <div className="page order-cancel">
      <h2>Payment Cancelled</h2>

      <p>Your payment was not completed.</p>
      <p>If this was a mistake, you can try again below.</p>

      <div style={{ marginTop: "1.5rem" }}>
        <Link to="/checkout" className="btn">
          Return to Checkout
        </Link>
      </div>

      <div style={{ marginTop: "1rem" }}>
        <Link to="/" className="btn-secondary">
          Back to Home
        </Link>
      </div>
    </div>
  );
}